import getLiveUrl from 'lib/get-live-url'
import { Wrapper } from 'lib/noop-wrapper'
import Link from 'next/link'
import React from 'react'

export interface ILiveLinkParams {
  id?: string
  webRid?: string
}

function liveLink({ id, webRid }: ILiveLinkParams): Wrapper {
  return (content) =>
    id ? (
      <React.Fragment>
        <Link href={getLiveUrl(id, webRid)}>
          <a target={'_blank'} className="g-active-link-text" rel="unsafe-url">
            {content}
          </a>
        </Link>
        <style jsx>
          {`
            a {
              color: inherit;
            }
          `}
        </style>
      </React.Fragment>
    ) : (
      content
    )
}

export default liveLink
